export const note = 'Ghi chú';
